import api from '../../api/api';

// TinyMCE images_upload_handler for campaign editors: the pasted image is dimmed (content_style img[data-uploading]) until
// the server has it; on failure TinyMCE removes it (remove:true) so a data:/blob: never ships
export const uploadEditorImage = (stockId: string, getEditor: () => any) => async (blobInfo: any) => {
    const img = getEditor()?.getBody().querySelector(`img[src="${blobInfo.blobUri()}"]`);
    img?.setAttribute('data-uploading', '');
    try {
        return await api().uploadCampaignEditorImage(stockId, blobInfo.blob(), blobInfo.filename());
    } catch (e: any) {
        throw { message: `Image upload failed: ${e?.response?.data || e?.message || e}`, remove: true };
    } finally {
        img?.removeAttribute('data-uploading');
    }
};
